// Přepne background/navbar/leftSidebar/rightSidebar naráz na 'dark' nebo 'light' -
// jednotný app-wide dark mode switch (viz LoginPage/v2).
export const setGlobalTheme = (mode) => ({
    type: 'SET_PALETTE',
    palette: {
        background: mode,
        leftSidebar: mode,
        navbar: mode,
        rightSidebar: mode
    }
})

export default function palettes(
  state = {
    background: 'light',
    leftSidebar: 'light',
    navbar: 'light',
    rightSidebar: 'light'
  },
  action
) {
  switch (action.type) {
    case 'SET_PALETTE':
      return {
        ...state,
        ...action.palette
      }
    case 'RESET_PALETTES':
      return {
        background: 'light',
        leftSidebar: 'light',
        navbar: 'light',
        rightSidebar: 'light'
      }
    default:
      return state
  }
}
